import React, {useEffect, useState} from 'react'
import {MenuItem, TextField} from '@mui/material'
import {GridRowModel} from '@mui/x-data-grid'
import {EditSheet} from '../../common/EditSheet'
import {Frequency, FrequencyCode, FrequencyNameMapping} from '../../../domain/Frequency'
import {getMonthName} from '../../../utils/formatValuesUtils'

type RecurrenceEditSheetProps = {
  open: boolean,
  row: GridRowModel,
  onClose: () => void,
  onSave: (updated: GridRowModel) => void,
  onDelete: (id: string) => void,
}

const monthOptions = Array.from({length: 12}, (_, i) => ({value: i + 1, label: getMonthName(i + 1)}))

export const RecurrenceEditSheet: React.FC<RecurrenceEditSheetProps> = ({open, row, onClose, onSave, onDelete}) => {
  const [draft, setDraft] = useState<GridRowModel>(row)

  useEffect(() => setDraft(row), [row])

  const set = (field: string, value: unknown) => setDraft(prev => ({...prev, [field]: value}))
  const isYearly = draft.frequency === FrequencyCode.YEAR

  const handleValidate = () => {onSave(draft); onClose()}

  return (
    <EditSheet open={open} title="Modifier la récurrence" onClose={onClose} onValidate={handleValidate} onDelete={() => onDelete(row.id)}>
      <TextField label="Description" value={draft.description ?? ''} onChange={(e) => set('description', e.target.value)} fullWidth/>
      <TextField label="Montant" type="number" value={draft.amount ?? 0} onChange={(e) => set('amount', parseFloat(e.target.value) || 0)} inputProps={{inputMode: 'decimal'}} fullWidth/>
      <TextField label="Fréquence" select value={draft.frequency} onChange={(e) => set('frequency', e.target.value as Frequency)} fullWidth>
        {Object.values(FrequencyCode).map(v => <MenuItem key={v} value={v}>{FrequencyNameMapping[v]}</MenuItem>)}
      </TextField>

      {isYearly ? (
        <TextField label="Mois annuel" select value={draft.onMonth ?? ''} onChange={(e) => set('onMonth', Number(e.target.value))} fullWidth>
          {monthOptions.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
        </TextField>
      ) : (
        <>
          <TextField label="Premier mois" select value={draft.startMonth ?? ''} onChange={(e) => set('startMonth', Number(e.target.value))} fullWidth>
            {monthOptions.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
          </TextField>
          <TextField label="Dernier mois" select value={draft.endMonth ?? ''} onChange={(e) => set('endMonth', Number(e.target.value))} fullWidth>
            {monthOptions.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
          </TextField>
        </>
      )}

      <TextField label="Premier année" type="number" value={draft.startYear ?? ''} onChange={(e) => set('startYear', e.target.value === '' ? undefined : Number(e.target.value))} fullWidth/>
      <TextField label="Dernière année" type="number" value={draft.endYear ?? ''} onChange={(e) => set('endYear', e.target.value === '' ? undefined : Number(e.target.value))} fullWidth/>
    </EditSheet>
  )
}
